<template>
    <div class="more darker moved-right">
        <h6 class="d-flex align-items-center dark pointer m-2 d-flex align-items-center" @click="backToList" style="padding-bottom: 0.0px">
            <i class="ico-arrow-left"></i>
            <span>Go to Filters</span>
        </h6>

        <div class="p-3 text-center" v-if="getIsloadingSelectedEvent">
            <loader></loader>
        </div>

        <div class="relative my-3 mx-1 border-right-light border-bottom-light border-left-light" v-else-if="event">
            <div class="box border-top-light shadowless">
                <div class="wrapper">

                    <div v-if="event.nameAlias">
                        <span v-if="product">{{ product.name }}</span>
                        <h3 v-if="product">{{ event.nameAlias }}</h3>
                    </div>
                    <h3 v-else-if="product">{{ product.name }}</h3>

                    <links :event="event"></links>

                </div>
            </div>

            <tabs-place :event="event"></tabs-place>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import { mapGetters, mapActions } from 'vuex'
    import TabsPlace from './EventTabs'
    import Links from './Links'
    import Loader from '@/tools/loaders/loader1'

    export default {
        created: function() {
            this.eventHub.$on('closeCalendarEventDetails', data => {
                this.backToList()
            })
        },
        computed: {
            ...mapGetters([
                'getSelectedEvent',
                'getIsloadingSelectedEvent'
            ]),
            event: function() {
                return this.getSelectedEvent;
            },
            product: function() {
                return this.event.product;
            },
            multipleDays: function() {
                return (this.formatDate(this.event.start) != this.formatDate(this.event.end));
            },
        },
        methods: {
            ...mapActions([
                'updateSelectedEvent'
            ]),
            toggleActions: function() {

            },
            backToList: function() {
                var vm = this;

                // Animate side panels
                $('.events').removeClass('showingMore');
                $('.events .list').removeClass('moved-left');
                $('.events .more').addClass('moved-right');

                // Wait until animation is over, then reset selected event

                setTimeout(function() {
                    vm.updateSelectedEvent(null);
                }, 400);
            }
        },
        components: {
            TabsPlace,
            Links,
            Loader
        }
    }
</script>

<style lang="scss">
    @import '../../assets/scss/_variables.scss';

    .events {
        .more {
            width: 100%;
            position: absolute;
            transition: transform 0.4s;

            .bullets {
                position: absolute;
                top: 1rem;
                right: 0.75rem;
            }

            h4 > .ico-arrow-left {
                font-size: 0.5rem;
            }

            .timeline {
                .ico-calendar {
                    margin-top: 4px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// EventMore.vue?aa226a58